var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.77,
    height: 124.316,
    viewBox: "0 0 120.77 124.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M193.374,60.592V3.494a3.494,3.494,0,1,0-6.988,0v57.1a17.744,17.744,0,0,0,0,34.787V120.8a3.494,3.494,0,1,0,6.988,0V95.379a17.744,17.744,0,0,0,0-34.787ZM189.88,88.727a10.741,10.741,0,1,1,10.741-10.741A10.748,10.748,0,0,1,189.88,88.727Z",
    transform: "translate(-129.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M28.074,31.292V3.494a3.494,3.494,0,0,0-6.988,0v27.8a17.744,17.744,0,0,0,0,34.787V120.8a3.494,3.494,0,1,0,6.988,0V66.053a17.728,17.728,0,0,0,0-34.761ZM24.58,59.427A10.741,10.741,0,1,1,35.321,48.686,10.748,10.748,0,0,1,24.58,59.427Z",
    transform: "translate(-6.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M357.674,31.292V3.494a3.494,3.494,0,0,0-6.988,0v27.8a17.744,17.744,0,0,0,0,34.787v54.742a3.494,3.494,0,0,0,6.988,0V66.053a17.728,17.728,0,0,0,0-34.761ZM354.18,59.427a10.741,10.741,0,1,1,10.741-10.741A10.748,10.748,0,0,1,354.18,59.427Z",
    transform: "translate(-251.14)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings1);
export default __webpack_public_path__ + "static/media/settings-1.344a78c4.svg";
export { ForwardRef as ReactComponent };